import React from 'react'
import { StyledIconPropsType } from './types'

const EditWMO = ({
  icon = "edit",
  viewBox= "0 0 40 40",
  width = "40",
  height = "40",
  customProps = {}
} : StyledIconPropsType) => {
  return (
    <svg aria-label={icon} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" {...customProps}>
      <path d="M18.334 6.6665H6.66732C5.78326 6.6665 4.93542 7.01769 4.31029 7.64281C3.68517 8.26794 3.33398 9.11578 3.33398 9.99984V33.3332C3.33398 34.2172 3.68517 35.0651 4.31029 35.6902C4.93542 36.3153 5.78326 36.6665 6.66732 36.6665H30.0007C30.8847 36.6665 31.7326 36.3153 32.3577 35.6902C32.9828 35.0651 33.334 34.2172 33.334 33.3332V21.6665" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M30.834 4.16688C31.497 3.50384 32.3963 3.13135 33.334 3.13135C34.2717 3.13135 35.1709 3.50384 35.834 4.16688C36.497 4.82992 36.8695 5.7292 36.8695 6.66688C36.8695 7.60456 36.497 8.50384 35.834 9.16688L20.0007 25.0002L13.334 26.6669L15.0007 20.0002L30.834 4.16688Z" stroke="#5E5E65" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default EditWMO
